export default "__VITE_ASSET__29e2aaf9__"